<script>
export default {
    name: 'IconCheque'
}
</script>
<template>
    <svg
        class="base-icon icon-cheque"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 16v32H8V16h48zm-32.031 8c-1.215 0-2.342.228-3.383.685a7.37 7.37 0 00-2.649 1.945 7.677 7.677 0 00-1.57 2.917H14v1.856h2.052c-.014.133-.02.332-.02.597 0 .265.006.464.02.597H14v1.856h2.366a7.677 7.677 0 001.571 2.917 7.37 7.37 0 002.65 1.945c1.04.457 2.167.685 3.382.685 1.27 0 2.418-.236 3.445-.707A6.855 6.855 0 0030 37.238l-2.157-2.122c-1.005 1.223-2.24 1.834-3.707 1.834-.921 0-1.745-.22-2.471-.663a4.411 4.411 0 01-1.675-1.834h5.298v-1.856h-5.822a5.097 5.097 0 01-.02-.446L19.445 32c0-.265.007-.464.021-.597h5.822v-1.856H19.99c.39-.78.949-1.392 1.675-1.834.726-.442 1.55-.663 2.471-.663 1.452 0 2.688.604 3.707 1.812L30 26.74a6.944 6.944 0 00-2.586-2.033c-1.027-.471-2.175-.707-3.445-.707zM50 34H40v4h10v-4zm0-8H34v4h16v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
